// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
			suggestionStyle: 'style2',
			suggestionMobileStyle: 'style2'
    }
};

// Override Settings
(function () {  // Add this
  BoostPFS.inject(this);  // Add this

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
  };

	InstantSearchResultItemProduct.prototype.afterRender = function() {

		if (!this.data || !this.isShow) return
		var priceVaries = this.data.price_min != this.data.price_max;
		this.$element.find('.boost-pfs-search-suggestion-product-price').append('<span>ex VAT</span>')
		if (priceVaries === true){
			this.$element.find('.boost-pfs-search-suggestion-product-price').prepend('<span>From</span>')
		}
		var isHiddenPrice = this.data['tags'].toString().toLowerCase().indexOf('price_on_application:yes') !== -1;

		if (isHiddenPrice === true) {
			this.$element.find('.boost-pfs-search-suggestion-product-price').remove();
		}
	}

})();  // Add this at the end
